export default __webpack_public_path__ + "static/media/About_Landing-10.45f31ed3.png";